import * as settingsTypes from './settings.types';

export const setStateSettingsReducer = (prop,value) => (dispatch) => {
    dispatch({ type: settingsTypes.SET_SETTINGS, payload: { prop,value } });
}